module.exports = __webpack_public_path__ + "static/cotoiro.bd2a2a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/cotoiro.png
// module id = 205
// module chunks = 35783957827783